module.exports = __webpack_public_path__ + "img/desire_002.9be4ab1.webp";